import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap/lib';

function TextInput({
  formData,
  name,
  label,
  placeholder,
  onChange,
  required,
  disabled,
  maxLength,
}) {
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <FormControl
        name={name}
        type="text"
        value={get(formData, name)}
        placeholder={placeholder}
        onChange={onChange}
        // Do not allow tags to be entered
        pattern="^(?=\S)((?!(<|>)).)*$"
        required={required !== false}
        maxLength={maxLength || '40'}
        disabled={disabled}
      />
    </FormGroup>
  );
}

TextInput.propTypes = {
  formData: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  maxLength: PropTypes.string,
};

export default TextInput;
